import {useMutation, useQuery} from '@tanstack/react-query';
import {DEVICE_CONFIRMATION} from 'constants/cache';
import {client} from 'helpers/api-client';

interface IUseGetDeviceConfirmationParams {
    hash?: string;
    uuid?: string;
}

interface IUseGetDeviceConfirmationResponse {
    uuid: string;
    compositeKey: string;
    userAgent: string;
    location: string;
    ip: string;
    createdAt: string;
    enabled: boolean;
}

const useGetDeviceConfirmation = ({
    hash,
    uuid,
}: IUseGetDeviceConfirmationParams) => {
    return useQuery<IUseGetDeviceConfirmationResponse>({
        queryKey: [DEVICE_CONFIRMATION],
        queryFn: () =>
            client(`/web_api/device-confirmation/${uuid}/${hash}`, {
                method: 'GET',
            }),
        enabled: !!hash && !!uuid,
    });
};

const useEnableDeviceConfirmation = () => {
    return useMutation({
        mutationFn: ({hash, uuid}: IUseGetDeviceConfirmationParams) =>
            client(`/web_api/device-confirmation/${uuid}/${hash}`, {
                method: 'POST',
                data: {},
            }),
    });
};

export {useGetDeviceConfirmation, useEnableDeviceConfirmation};
